<template lang="pug">
  .kpi-situation(v-loading="loading")
    span(v-if="viewData != null && viewData.length === 0 && !isEdit") —
    el-table(
      v-if="isEdit && kpiInfo"
      :data="value"
      :key="'edit_kpiSituation'"
    )
      el-table-column(
        :label="$t('KPI')"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          span {{ $t(scope.row.kpi_name) }}
      el-table-column(
        :label="$t('量化指标')"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          span {{ numberWithCommas(scope.row.target, 0, false) }} {{ $t(kpiInfo.find(k => k.kpi_id === scope.row.kpi_id).unit) }}
      el-table-column(
        :label="$t('占比')"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          span {{ scope.row.kpi_percent + '%' }}
      el-table-column(
        :label="$t('完成情况')"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          input-with-commas(
            v-model="scope.row.actual"
            inputStyle="width: 180px; margin-right: 5px"
            :unit="kpiInfo.find(k => k.kpi_id === scope.row.kpi_id).unit"
            @change="calcActualPercent(scope.row)"
          )
      el-table-column(
        :label="$t('完成比例')"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          template(v-if="scope.row.kpi_type === 1")
            span(v-if="scope.row.actual_percent && scope.row.actual_percent !== 'Infinity'") {{ scope.row.actual_percent }}%
            span(v-else) —
          el-input(
            v-else
            style="width: 100px"
            v-model="scope.row.actual_percent"
          )
            span(slot="suffix") %
      el-table-column(
        :label="$t('支持文件')"
        show-overflow-tooltip
        min-width="160"
      )
        template(slot-scope="scope")
          div(style="display: flex; align-items: center;")
            new-upload-file(
              style="margin-right: 5px"
              axiosUrl="/management/subfinal/saveFile"
              :params="uploadParams"
              @loadingChange="status => loading = status"
              @uploadSuccess="res => uploadSuccess(res, scope.row)"
            )
            uploaded-file-display(
              :fileName="scope.row.file_name"
              :downloadUrl="scope.row.file_download_path"
              :fileNameList="scope.row.file_name_list"
              width="95px"
            )
    el-table(
      v-if="!isEdit && kpiInfo"
      :data="viewData"
      :key="'view_kpiSituation'"
    )
      el-table-column(
        :label="$t('KPI')"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          span {{ $t(scope.row.kpi_name) }}
      el-table-column(
        :label="$t('量化指标')"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          span {{ numberWithCommas(scope.row.target, 0, false) }} {{ $t(kpiInfo.find(k => k.kpi_id === scope.row.kpi_id).unit) }}
      el-table-column(
        :label="$t('占比')"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          span {{ scope.row.kpi_percent + '%' }}
      el-table-column(
        :label="$t('完成情况')"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          span(v-if="scope.row.actual") {{ numberWithCommas(scope.row.actual, 0, false) }} {{ $t(kpiInfo.find(k => k.kpi_id === scope.row.kpi_id).unit) }}
          span(v-else) {{ scope.row }}
      el-table-column(
        :label="$t('完成比例')"
        show-overflow-tooltip
        width="145"
      )
        template(slot-scope="scope")
          span(v-if="scope.row.actual_percent != null") {{ scope.row.actual_percent | numberWithCommas }}%
          span(v-else) —
      el-table-column(
        :label="$t('支持文件')"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          uploaded-file-display(
            v-if="scope.row.file_name"
            :fileName="scope.row.file_name"
            :downloadUrl="scope.row.file_download_path"
            :fileNameList="scope.row.file_name_list"
            width="85px"
          )
          span(v-else) —

</template>

<script>
import axios from 'axios'
import { numberWithCommas, formatMoney, formatKPI } from '@/umcc/util'
import InputWithCommas from '@/components/InputWithCommas'
import { KPIMap } from '@/umcc/constant.js'
import NewUploadFile from '@/components/NewUploadFile'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'

const REVERSE_PERCENT_KPI = ['CPM', 'CPC']

export default {
  components: {
    InputWithCommas,
    NewUploadFile,
    UploadedFileDisplay
  },
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    },
    viewData: {
      type: Array,
      default () {
        return []
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    numberWithCommas,
    formatMoney,
    formatKPI
  },
  data () {
    return {
      KPIMap,
      REVERSE_PERCENT_KPI,
      loading: false,
      kpiInfo: null
    }
  },
  computed: {
    uploadParams () {
      return {
        file_type: 6
      }
    },
    subFinalScopeId () {
      return this.$store.state.campaign.subFinalScopeId
    }
  },
  mounted () {
    if (!this.subFinalScopeId) return
    axios.get('/management/subfinal/getKpiInfo', {
      params: { sub_final_scope_id: this.$store.state.campaign.subFinalScopeId }
    })
      .then(res => {
        this.kpiInfo = res
        // this.$emit('input', res.map(i => ({
        //   kpi_id: i.kpi_id,
        //   kpi_name: i.kpi_name,
        //   kpi_type: i.kpi_type,
        //   actual: i.actual || '',
        //   actual_percent: i.actual_percent,
        //   file_path: i.file_path,
        //   file_name: i.file_name,
        //   file_download_path: i.file_download_path,
        //   file_name_list: i.file_name_list,
        //   target: i.target,
        //   kpi_percent: i.kpi_percent
        // })))
      })
  },
  methods: {
    toPercent (num) {
      return isNaN(num) ? '' : (num * 100).toFixed(0)
    },
    calcActualPercent (kpi) {
      if (kpi.kpi_type === 1) {
        kpi.actual_percent = REVERSE_PERCENT_KPI.includes(kpi.kpi_name) ? ((kpi.target / kpi.actual) * 100).toFixed(0) : ((kpi.actual / kpi.target) * 100).toFixed(0)
      }
    },
    uploadSuccess (res, kpi) {
      kpi.file_path = res.file_path
      kpi.file_name = res.file_name
      kpi.file_download_path = res.file_download_path
      kpi.file_name_list = res.file_name_list
      this.loading = false
    },
    numberWithCommas,
    getUnitById (id) {
      return this.kpiInfo.find(k => k.kpi_id === id).unit
    },
    getNormalizerById (id, val) {
      const normalizer = {
        '元': val => formatMoney(val, 2),
        '%': val => numberWithCommas(val, 2),
        '次': val => numberWithCommas(val)
      }
      const normalize = normalizer[this.getUnitById(id)]
      if (normalize) return normalize(val)
      return val
    }
  }
}
</script>

<style lang="stylus">
.kpi-situation
  .el-row
    margin 0 !important
  .input-with-commas
    .el-input
      width auto !important
.kpi-situation__header
  color #000
  .el-col
    height 36px
    line-height 36px
    text-align center
.kpi-situation__title
  background #edf2fa
  color #3370d2

.kpi-situation__body
  .el-col
    height 36px
    line-height 36px
    text-align center
  &:last-child > div
    border-bottom 1px solid #4896e6 !important
</style>
